import React, { forwardRef, useState } from 'react';
import { Alert } from '../';
import Popper from '@mui/base/Popper';
import ClickAwayListener from '@mui/base/ClickAwayListener';

interface FavoriteProps {
  isFav: boolean;
  isOpen: boolean;
  title: string;
  closeFunc: any;
}

const Favorite = forwardRef<HTMLInputElement, FavoriteProps>(function Favorite(props, ref) {
  const { isFav, isOpen, title, closeFunc } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClickAway = () => {
    closeFunc();
  };
  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div ref={(elm) => setAnchorEl(elm)}>
        <Popper
          open={isOpen}
          anchorEl={anchorEl}
          placement="bottom"
          className="inset-[0px_auto_auto_0px] bg-white shadow-[0_6px_8px_0_rgba(34,34,34,0.2)] w-auto"
        >
          <Alert
            key={0}
            open={true}
            type={isFav ? 'success' : 'error'}
            white
            className="print:hidden w-full self-start p-2"
            title={title}
            onClose={closeFunc}
            content={<span></span>}
          />
        </Popper>
      </div>
    </ClickAwayListener>
  );
});
export { Favorite };
